import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';

export function* executeAssignmentActionSaga(action) {
    try {
        yield put(reduceLoading({ code: 'executeAssignmentAction', value: true }));
        const session = yield getSessionSaga();
        const response = yield call(fetch, '/api/policyTransaction/action/AssignBroker', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                parameters: [
                    {
                        code: 'BrokerReference',
                        value: action.payload.assignedTo,
                    },
                ],
                policyTransaction: {
                    guid: action.payload.guid,
                },
            }),
        });
        const result = yield call([response, 'json']);

        yield put(reduceOperation(result.operation));
        if (!result.operation.status) {
            yield put(reduceLoading({ code: 'executeAssignmentAction', value: false }));
            return;
        }
        yield put(reduceLoading({ code: 'executeAssignmentAction', value: false }));
        return;
    } catch (error) {
        console.log('Error while Executing Assignment Action API - ', error);
        yield put(reduceLoading({ code: 'executeAssignmentAction', value: false }));
        return;
    }
}
